import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Landing from './components/Landing';
import Product from './components/Product';
import ProductInformation from './components/ProductInformation';
import WhereToBuy from './components/WhereToBuy';
import { useCustomTheme } from './hooks/use-custom-theme';

function App() {
  const [params] = useSearchParams();
  const page = params.get('page');
  useCustomTheme();
  switch (page) {
    case '':
    case 'wheretobuy':
      return <WhereToBuy />;
    case 'recommendedProducts':
      return <Product />;
    case 'product':
      return <ProductInformation />;
    default:
      return <Landing />;
  }
}

export default App;
